import { useState } from 'react';
import { Button } from '../ui/Button';
import { useDossiers } from '../../hooks/queries/useDossiers';
import { useTasks } from '../../hooks/queries/useTasks';

interface Props {
  onConfirm: (dossierId: string, taskId: string | null) => void;
  onCancel: () => void;
}

export function TimerStartPopover({ onConfirm, onCancel }: Props) {
  const [dossierId, setDossierId] = useState<string>('');
  const [taskId, setTaskId] = useState<string>('');
  const { data: dossiers } = useDossiers({});
  const { data: tasks } = useTasks(dossierId ? { dossier_id: dossierId } : undefined);

  return (
    <div className="w-72 rounded-cime border border-neutral-200 bg-cime-surface p-4 shadow-xl">
      <p className="mb-2 text-sm font-semibold text-neutral-900">Démarrer un chrono</p>

      <label htmlFor="timer-dossier" className="mb-1 block text-xs text-neutral-600">Dossier *</label>
      <select
        id="timer-dossier"
        className="mb-3 w-full rounded-md border border-neutral-300 px-2 py-1.5 text-sm"
        value={dossierId}
        onChange={(e) => { setDossierId(e.target.value); setTaskId(''); }}
      >
        <option value="">— Choisir —</option>
        {(dossiers ?? []).map((d) => (
          <option key={d.id} value={d.id}>
            {d.rg_number ? `${d.rg_number} — ${d.title}` : d.title}
          </option>
        ))}
      </select>

      <label htmlFor="timer-task" className="mb-1 block text-xs text-neutral-600">Tâche (optionnel)</label>
      <select
        id="timer-task"
        className="mb-4 w-full rounded-md border border-neutral-300 px-2 py-1.5 text-sm"
        value={taskId}
        onChange={(e) => setTaskId(e.target.value)}
        disabled={!dossierId}
      >
        <option value="">— Aucune —</option>
        {(tasks ?? []).map((t) => (
          <option key={t.id} value={t.id}>{t.content}</option>
        ))}
      </select>

      <div className="flex justify-end gap-2">
        <Button type="button" variant="ghost" size="sm" onClick={onCancel}>Annuler</Button>
        <Button type="button" size="sm" disabled={!dossierId} onClick={() => onConfirm(dossierId, taskId || null)}>
          Démarrer
        </Button>
      </div>
    </div>
  );
}
